import { DynamicPropertyType } from 'types/DynamicPropertyType';

import type DynamicGroup from './Group';
import { DynamicProperty } from './Property';

export default class SVGData extends DynamicProperty<string> {
  type = DynamicPropertyType.SVGData;
  name = 'SVGData';
  value = '';

  constructor(parent: DynamicGroup, name: string, value: string) {
    super(parent, name, value);
    // this.becomeObservable();
  }

  getChanged = () => {
    // TODO: This is a temporary fix. Real fix needs to be found. Generally SVGData is more like meta data. So it being changed isn't generally important to know.
    return false;
  };
}
